import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';

import { CommonService } from './shared/service/common.service';
import { AdminContactService } from './shared/service/admin-contact.service';
import { FileUploadService } from './shared/service/file-upload.service';

import { HttpClientModule } from '@angular/common/http';
import {
  MatTableModule, MatPaginatorModule, MatInputModule, MatSortModule, MatFormFieldModule, MatButtonModule, MatToolbarModule, MatTabsModule, MatSelectModule,
  MatDatepickerModule, MatNativeDateModule, MatDialogModule, MatRadioModule, MatCardModule
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ng2-ckeditor';
import { AdminAboutComponent } from './admin-about/admin-about.component';
import { AdminContactComponent } from './admin-contact/admin-contact.component';
import { AdminDestinationComponent, AdminDestinationsDialog } from './admin-destination/admin-destination.component';
import { BlockUIModule } from 'ng-block-ui';
import { AdminContactAccountComponent, AdminContactAccountDialog } from './admin-contact-account/admin-contact-account.component';
import { AdminContactOfficeComponent, AdminContactOfficeDialog } from './admin-contact-office/admin-contact-office.component';
import { AdminContactFranchisesComponent, AdminContactFrachisesDialog } from './admin-contact-franchises/admin-contact-franchises.component';
import { AdminToursService } from './shared/service/admin-tours.service';
import { AdminToursComponent, AdminToursDialog } from './admin-tours/admin-tours.component';
import { AllToursComponent } from './all-tours/all-tours.component';
import { PagerService } from './shared/service/pager.service';
import { ToursDetailsComponent, WriteReviewDialog } from './tours-details/tours-details.component';
import { AdminToursDetailsComponent } from './admin-tours-details/admin-tours-details.component';
import { AdminHotelsComponent } from './admin-hotels/admin-hotels.component';
import { AdminHotelsService } from './shared/service/admin-hotels.service';
import { AdminDestinationService } from './shared/service/admin-destination.service';
import { AdminUsersComponent, AdminUsersDialog } from './admin-users/admin-users.component';
import { AdminUsersService } from './shared/service/admin-users.service';
import { AdminMenuComponent, AdminMenuDialog, HeadingDialog, SubMenuLinksDialog } from './admin-menu/admin-menu.component';
import { AdminMenuService } from './shared/service/admin-menu.service';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { AdminInquiryComponent } from './admin-inquiry/admin-inquiry.component';
import { AdminInquiryService } from './shared/service/admin-inquiry.service';
import { InquiryComponent } from './inquiry/inquiry.component';
import { AutoLogoutService } from './shared/service/auto-logout.service';
import { AdminLatestTemplateComponent } from './admin-latest-template/admin-latest-template.component';
import { AdminLatestTemplateService } from './shared/service/admin-latest-template.service';
import { AdminHomeSliderComponent, AdminHomeSliderDialog } from './admin-home-slider/admin-home-slider.component';
import { AdminHomeSliderService } from './shared/service/admin-home-slider.service';
import { BusPackagesComponent } from './bus-packages/bus-packages.component';
import { MatCarouselModule } from '@ngmodule/material-carousel';

import { RatingModule } from 'ng-starrating';
import { AdminReviewComponent, EditReviewDialog } from './admin-review/admin-review.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutComponent,
    ContactComponent,
    AdminAboutComponent,
    AdminContactComponent,
    AdminDestinationComponent,
    AdminDestinationComponent,
    AdminContactAccountComponent,
    AdminContactOfficeComponent,
    AdminContactFranchisesComponent,
    AdminToursComponent,
    AllToursComponent,
    AdminToursDialog,
    AdminDestinationsDialog,
    ToursDetailsComponent,
    AdminToursDetailsComponent,
    AdminHotelsComponent,
    AdminUsersComponent,
    AdminUsersDialog,
    AdminMenuDialog,
    HeadingDialog,
    SubMenuLinksDialog,
    AdminMenuComponent,
    AdminLoginComponent,
    NotFoundComponent,
    AdminContactOfficeDialog,
    AdminContactFrachisesDialog,
    AdminContactAccountDialog,
    AdminHomeSliderDialog,
    AdminInquiryComponent,
    InquiryComponent,
    AdminLatestTemplateComponent,
    AdminHomeSliderComponent,
    BusPackagesComponent,
    WriteReviewDialog,
    AdminReviewComponent,
    EditReviewDialog
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatSortModule,
    MatToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    MatTabsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCardModule,
    MatDialogModule,
    BlockUIModule.forRoot(),
    RatingModule,
    MatCarouselModule
  ],
  entryComponents: [AdminToursDialog, AdminDestinationsDialog, AdminUsersDialog, AdminMenuDialog, HeadingDialog, SubMenuLinksDialog, AdminContactOfficeDialog, AdminContactFrachisesDialog, AdminContactAccountDialog, InquiryComponent, AdminHomeSliderDialog, WriteReviewDialog, EditReviewDialog],
  providers: [CommonService, AdminContactService, FileUploadService, AdminToursService, PagerService, AdminHotelsService, AdminDestinationService, AdminUsersService, AdminMenuService, AdminInquiryService, AutoLogoutService, AdminLatestTemplateService, AdminHomeSliderService],
  bootstrap: [AppComponent]
})
export class AppModule { }
